/* eslint-disable @reatom/unit-naming-rule */
import { useAction, useAtom } from '@reatom/npm-react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'use-memo-one'

import { AsyncStateN } from '@blade/std-lib'
import { reatomUnassignTwitter } from '@root/features/auth/twitter/atoms'
import { useBreakpoint } from '@root/shared'
import { ConfirmDialog, ConfirmDrawer } from '@root/shared/ui-kit'

import type { DialogControlProps } from '@root/shared/ui-kit'

type Props = DialogControlProps
export const SettingsTwitterUnassignConfirm: React.FC<Props> = ({
  onOpenChange,
  open,
}) => {
  const { t } = useTranslation()
  const breakpoint = useBreakpoint()
  const unassignModel = useMemo(() => reatomUnassignTwitter(), [])

  const [unassignState] = useAtom(unassignModel)
  const unassign = useAction(unassignModel.execute)

  const ConfirmCmp = breakpoint === 'mobile' ? ConfirmDrawer : ConfirmDialog

  useEffect(() => {
    if (AsyncStateN.isSuccess(unassignState)) {
      onOpenChange?.(false)
    }
  }, [unassignState, onOpenChange])

  return (
    <>
      <ConfirmCmp
        intent="error"
        open={open ?? false}
        onOpenChange={onOpenChange}
        title={t('settings.twitter.disconnect-title')}
        describedBy={t('settings.twitter.disconnect-title')}
        description={t('settings.twitter.disconnect-description')}
        busy={unassignState.loading}
        onConfirm={() => unassign()}
        onCancel={() => onOpenChange?.(false)}
      />
    </>
  )
}
